import { render, staticRenderFns } from "./POrderGrid.vue?vue&type=template&id=19ad4382"
import script from "./POrderGrid.vue?vue&type=script&lang=js"
export * from "./POrderGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports